(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grand-hotel-order-request"]) return;
  try {
    
(() => {
 const init = root => {
  const form = root.querySelector('.gh-request__form');
  const review = root.querySelector('[data-gh-request-review]');
  if (!form || !review || form.dataset.ready) return;
  form.dataset.ready = 'true';
  const inputs = [...form.querySelectorAll('[data-gh-request-quantity]')];
  const po = form.querySelector('[data-gh-request-po]');
  const notes = form.querySelector('[data-gh-request-notes]');
  const body = form.querySelector('[data-gh-request-body]');
  const status = form.querySelector('[data-gh-request-status]');
  const panel = form.querySelector('[data-gh-request-confirm]');
  const send = form.querySelector('[data-gh-request-send]');
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents / 100) + ' USD';
  let reviewed = '';
  const read = () => {
   let total = 0;
   const items = [];
   for (const input of inputs) {
    const quantity = input.value.trim() === '' ? 0 : Number(input.value);
    const cents = Number(input.dataset.cents);
    if (!Number.isSafeInteger(quantity) || quantity < 0 || !Number.isSafeInteger(cents * quantity) || !input.checkValidity()) throw new Error(root.dataset.invalidMessage);
    if (quantity > 0) { items.push({title:input.dataset.title,quantity,cents}); total += cents * quantity; }
   }
   if (!Number.isSafeInteger(total)) throw new Error(root.dataset.invalidMessage);
   return {items,total,po:po.value.trim(),notes:notes.value.trim()};
  };
  const clear = () => { reviewed = ''; panel.hidden = true; send.disabled = true; body.value = ''; };
  form.addEventListener('input', () => {
   clear(); status.textContent = '';
   try { form.querySelector('[data-gh-request-total]').textContent = money(read().total); } catch (error) { status.textContent = error.message; }
  });
  review.addEventListener('click', () => {
   clear();
   try {
    const data = read();
    if (!data.items.length) throw new Error(root.dataset.emptyMessage);
    if (!form.checkValidity()) { form.reportValidity(); return; }
    const lines = data.items.map(item => item.quantity + ' × ' + item.title + ' — ' + money(item.cents) + ' / ' + money(item.cents * item.quantity));
    const list = form.querySelector('[data-gh-request-lines]'); list.replaceChildren();
    for (const text of lines) { const li = document.createElement('li'); li.textContent = text; list.append(li); }
    const parts = [body.dataset.title, ...lines, body.dataset.subtotalLabel + ': ' + money(data.total), body.dataset.delivery, body.dataset.terms, body.dataset.pending];
    if (data.po) parts.push(body.dataset.poLabel + ': ' + data.po);
    if (data.notes) parts.push(body.dataset.notesLabel + ': ' + data.notes);
    body.value = parts.join('\n'); reviewed = JSON.stringify(data); status.textContent = ''; panel.hidden = false; send.disabled = false; panel.querySelector('h2').focus();
   } catch (error) { status.textContent = error.message; status.focus(); }
  });
  form.querySelector('[data-gh-request-edit]').addEventListener('click', () => { clear(); inputs[0]?.focus(); });
  form.addEventListener('submit', event => {
   try {
    if (!reviewed || reviewed !== JSON.stringify(read()) || !form.checkValidity()) throw new Error(root.dataset.changedMessage);
    status.textContent = root.dataset.sendingMessage;
   } catch (error) { event.preventDefault(); clear(); status.textContent = error.message; status.focus(); }
  });
  review.disabled = false;
 };
 document.querySelectorAll('[data-gh-request]').forEach(init);
 document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gh-request]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grand-hotel-ordering"]) return;
  try {
    
  function initializeGrandHotelOrdering(root = document) {
    root.querySelectorAll('[data-gh-order-form]').forEach((form) => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const inputs = [...form.querySelectorAll('[data-gh-quantity]')];
      const button = form.querySelector('[data-gh-submit]');
      const status = form.querySelector('[data-gh-status]');
      const total = form.querySelector('[data-gh-subtotal]');
      const currency = window.Shopify?.currency?.active || 'USD';
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency});
      let ready = false;
      const updateTotal = () => {
        const cents = inputs.reduce((sum,input) => sum + (Number(input.value) || 0) * Number(input.dataset.unitPrice), 0);
        total.textContent = formatter.format(cents / 100);
      };
      const showError = (message) => { status.textContent = message; status.focus(); };
      const readCart = async () => {
        const response = await fetch(form.dataset.cartUrl + '.js', {credentials:'same-origin',headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error(form.dataset.errorMessage);
        return response.json();
      };
      form.addEventListener('input', updateTotal);
      readCart().then((cart) => {
        inputs.forEach((input) => {
          input.value = String(cart.items.filter((item) => String(item.variant_id) === input.dataset.variantId).reduce((sum,item) => sum + item.quantity,0));
        });
        updateTotal();
        ready = true;
        button.disabled = inputs.length === 0;
      }).catch(() => showError(form.dataset.errorMessage));
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!ready || button.disabled) return;
        if (!form.reportValidity()) return;
        let positive = false;
        const updates = {};
        for (const input of inputs) {
          const quantity = Number(input.value);
          const minimum = Number(input.dataset.ruleMin || 1);
          const increment = Number(input.step || 1);
          if (!Number.isSafeInteger(quantity) || quantity < 0 || (quantity > 0 && (quantity < minimum || quantity % increment !== 0))) {
            showError(form.dataset.quantityMessage); input.focus(); return;
          }
          if (quantity > 0) positive = true;
          updates[input.dataset.variantId] = quantity;
        }
        if (!positive) { showError(form.dataset.emptyMessage); return; }
        button.disabled = true;
        form.setAttribute('aria-busy','true');
        status.textContent = form.dataset.busyMessage;
        try {
          const cart = await readCart();
          if (cart.items.some((item) => !Object.hasOwn(updates,String(item.variant_id)))) throw new Error(form.dataset.mixedMessage);
          const response = await fetch(form.dataset.updateUrl, {
            method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
            body:JSON.stringify({updates,attributes:{...cart.attributes,'Purchase order number':form.querySelector('[data-gh-po]').value.trim()},note:form.querySelector('[data-gh-notes]').value.trim()})
          });
          if (!response.ok) throw new Error(form.dataset.errorMessage);
          const saved = await response.json();
          if (Object.entries(updates).some(([id,quantity]) => saved.items.filter((item) => String(item.variant_id) === id).reduce((sum,item) => sum + item.quantity,0) !== quantity)) throw new Error(form.dataset.errorMessage);
          status.textContent = form.dataset.readyMessage;
          window.location.assign(form.dataset.cartUrl);
        } catch (error) { showError(error.message || form.dataset.errorMessage); button.disabled = false; form.removeAttribute('aria-busy'); }
      });
    });
  }
  initializeGrandHotelOrdering();
  document.addEventListener('shopify:section:load', (event) => initializeGrandHotelOrdering(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monet-collection-film"] && !Shopify.designMode) return;
  try {
    

function initializeMonetCollectionFilms() {
  document.querySelectorAll('[data-monet-collection-film]').forEach((root) => {
    if (root.dataset.filmInitialized) return;
    const video = root.querySelector('video');
    const button = root.querySelector('button');
    if (!video || !button) return;
    root.dataset.filmInitialized = 'true';
    const portrait = window.matchMedia('(max-width:699px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let pausedByUser = false;
    let allowMotion = !reducedMotion.matches;
    const updateButton = () => {
      const playing = !video.paused;
      button.dataset.playing = String(playing);
      button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
    };
    const syncPlayback = () => {
      if (visible && !pausedByUser && allowMotion) {
        video.play().catch(updateButton);
      } else {
        video.pause();
      }
    };
    const selectSource = () => {
      const src = portrait.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      const poster = portrait.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      if (video.getAttribute('src') === src) return;
      video.poster = poster;
      video.src = src;
      video.muted = true;
      video.load();
      syncPlayback();
    };
    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    video.addEventListener('loadedmetadata', syncPlayback);
    button.addEventListener('click', () => {
      if (video.paused) {
        pausedByUser = false;
        allowMotion = true;
        video.play().catch(updateButton);
      } else {
        pausedByUser = true;
        video.pause();
      }
    });
    portrait.addEventListener('change', selectSource);
    reducedMotion.addEventListener('change', () => {
      allowMotion = !reducedMotion.matches;
      syncPlayback();
    });
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      syncPlayback();
    }, {threshold:0.1});
    observer.observe(video);
    selectSource();
    button.hidden = false;
    updateButton();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMonetCollectionFilms, {once:true});
} else {
  initializeMonetCollectionFilms();
}
document.addEventListener('shopify:section:load', initializeMonetCollectionFilms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monet-la-mer-film"] && !Shopify.designMode) return;
  try {
    
function initializeMonetLaMerFilms() {
  document.querySelectorAll('[data-monet-la-mer-film]').forEach((root) => {
    if (root.dataset.filmInitialized) return;
    const video = root.querySelector('video');
    const button = root.querySelector('button');
    if (!video || !button) return;
    root.dataset.filmInitialized = 'true';
    const portrait = window.matchMedia('(max-width:699px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let pausedByUser = false;
    let allowMotion = !reducedMotion.matches;
    const updateButton = () => {
      const playing = !video.paused;
      button.dataset.playing = String(playing);
      button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
    };
    const syncPlayback = () => {
      if (visible && !pausedByUser && allowMotion) {
        video.play().catch(updateButton);
      } else {
        video.pause();
      }
    };
    const selectSource = () => {
      const src = portrait.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      const poster = portrait.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      if (video.getAttribute('src') === src) return;
      video.poster = poster;
      video.src = src;
      video.muted = true;
      video.load();
      syncPlayback();
    };
    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    video.addEventListener('loadedmetadata', syncPlayback);
    button.addEventListener('click', () => {
      if (video.paused) {
        pausedByUser = false;
        allowMotion = true;
        video.play().catch(updateButton);
      } else {
        pausedByUser = true;
        video.pause();
      }
    });
    portrait.addEventListener('change', selectSource);
    reducedMotion.addEventListener('change', () => {
      allowMotion = !reducedMotion.matches;
      syncPlayback();
    });
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      syncPlayback();
    }, {threshold:0.1});
    observer.observe(video);
    selectSource();
    button.hidden = false;
    updateButton();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMonetLaMerFilms, {once:true});
} else {
  initializeMonetLaMerFilms();
}
document.addEventListener('shopify:section:load', initializeMonetLaMerFilms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monet-signature-film"] && !Shopify.designMode) return;
  try {
    
function initializeMonetSignatureFilms() {
  document.querySelectorAll('[data-monet-signature-film]').forEach((root) => {
    if (root.dataset.filmInitialized) return;
    const video = root.querySelector('video');
    const button = root.querySelector('button');
    if (!video || !button) return;
    root.dataset.filmInitialized = 'true';
    const portrait = window.matchMedia('(max-width:699px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false;
    let pausedByUser = false;
    let allowMotion = !reducedMotion.matches;
    const updateButton = () => {
      const playing = !video.paused;
      button.dataset.playing = String(playing);
      button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
    };
    const syncPlayback = () => {
      if (visible && !pausedByUser && allowMotion) {
        video.play().catch(updateButton);
      } else {
        video.pause();
      }
    };
    const selectSource = () => {
      const src = portrait.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
      const poster = portrait.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
      if (video.getAttribute('src') === src) return;
      video.poster = poster;
      video.src = src;
      video.muted = true;
      video.load();
      syncPlayback();
    };
    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    video.addEventListener('loadedmetadata', syncPlayback);
    button.addEventListener('click', () => {
      if (video.paused) {
        pausedByUser = false;
        allowMotion = true;
        video.play().catch(updateButton);
      } else {
        pausedByUser = true;
        video.pause();
      }
    });
    portrait.addEventListener('change', selectSource);
    reducedMotion.addEventListener('change', () => {
      allowMotion = !reducedMotion.matches;
      syncPlayback();
    });
    const observer = new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      syncPlayback();
    }, {threshold:0.1});
    observer.observe(video);
    selectSource();
    button.hidden = false;
    updateButton();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeMonetSignatureFilms, {once:true});
} else {
  initializeMonetSignatureFilms();
}
document.addEventListener('shopify:section:load', initializeMonetSignatureFilms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monet-signature-gallery"] && !Shopify.designMode) return;
  try {
    
function initializeMonetSignatureGalleries() {
  document.querySelectorAll('[data-monet-signature-gallery]').forEach((root) => {
    if (root.dataset.galleryInitialized) return;
    root.dataset.galleryInitialized = 'true';
    const portrait = window.matchMedia('(max-width:699px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const grid = root.querySelector('[data-gallery-grid]');
    const cards = Array.from(root.querySelectorAll('[data-gallery-card]'));
    const controls = root.querySelector('[data-gallery-controls]');
    const previous = controls.querySelector('[data-gallery-previous]');
    const next = controls.querySelector('[data-gallery-next]');
    const progress = controls.querySelector('[data-gallery-progress]');
    let current = 0;
    let queued = false;
    const updateNavigation = () => {
      controls.hidden = !portrait.matches || cards.length < 2;
      if (cards.length) {
        const firstOffset = cards[0].offsetLeft;
        let distance = Infinity;
        cards.forEach((card, index) => {
          const candidate = Math.abs(card.offsetLeft - firstOffset - grid.scrollLeft);
          if (candidate < distance) { distance = candidate; current = index; }
        });
      }
      previous.disabled = current === 0;
      next.disabled = current === cards.length - 1;
      progress.textContent = progress.dataset.counterTemplate.replace('__CURRENT__', String(current + 1));
    };
    const goToCard = (index) => {
      if (!cards[index]) return;
      grid.scrollTo({left: cards[index].offsetLeft - cards[0].offsetLeft, behavior: reducedMotion.matches ? 'auto' : 'smooth'});
    };
    previous.addEventListener('click', () => goToCard(current - 1));
    next.addEventListener('click', () => goToCard(current + 1));
    grid.addEventListener('scroll', () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { updateNavigation(); queued = false; });
    }, {passive:true});
    portrait.addEventListener('change', updateNavigation);
    cards.forEach((card) => {
      const video = card.querySelector('video');
      const button = card.querySelector('.monet-signature-gallery__toggle');
      if (!video || !button) return;
      let visible = false;
      let pausedByUser = false;
      let allowMotion = !reducedMotion.matches;
      const updateButton = () => {
        const playing = !video.paused;
        button.dataset.playing = String(playing);
        button.setAttribute('aria-label', playing ? button.dataset.pauseLabel : button.dataset.playLabel);
      };
      const syncPlayback = () => {
        if (visible && !document.hidden && !pausedByUser && allowMotion) video.play().catch(updateButton);
        else video.pause();
      };
      const selectSource = () => {
        const src = portrait.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        const poster = portrait.matches ? video.dataset.mobilePoster : video.dataset.desktopPoster;
        if (video.getAttribute('src') === src) return;
        video.poster = poster;
        video.src = src;
        video.muted = true;
        video.load();
        syncPlayback();
      };
      video.addEventListener('play', updateButton);
      video.addEventListener('pause', updateButton);
      video.addEventListener('loadedmetadata', syncPlayback);
      button.addEventListener('click', () => {
        if (video.paused) { pausedByUser = false; allowMotion = true; video.play().catch(updateButton); }
        else { pausedByUser = true; video.pause(); }
      });
      portrait.addEventListener('change', selectSource);
      reducedMotion.addEventListener('change', () => { allowMotion = !reducedMotion.matches; syncPlayback(); });
      document.addEventListener('visibilitychange', syncPlayback);
      const observer = new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .4;
        syncPlayback();
      }, {threshold:[0,.4,1]});
      observer.observe(video);
      selectSource();
      button.hidden = false;
      updateButton();
    });
    updateNavigation();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeMonetSignatureGalleries, {once:true});
else initializeMonetSignatureGalleries();
document.addEventListener('shopify:section:load', initializeMonetSignatureGalleries);

  } catch(e) { console.error(e); }
})();
})();
